import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import * as bookmarks from '../../utils/bookmarks';
import { kebabToPascal } from '../../utils/caseconverters';
import styles from './NavigationFavorite.module.scss';

const NavigationFavorite = ({ favoritesPageUrl = '', theme = 'default', isMinimal = false }) => {
    const { t } = useTranslation('common');
    const [isActive, setIsActive] = useState(false);
    const [favoritesCount, setFavoritesCount] = useState(0);

    const handleBookmarksUpdated = (updatedBookmarks) => setFavoritesCount(updatedBookmarks.length);

    useEffect(() => {
        setFavoritesCount(bookmarks.getBookmarks().length);

        setIsActive(typeof window !== 'undefined' && window.location.href === favoritesPageUrl);

        bookmarks.onBookmarksUpdated(handleBookmarksUpdated);
        return () => {
            bookmarks.removeOnBookmarksUpdated(handleBookmarksUpdated);
        };
    }, [favoritesPageUrl]);

    const themeModifier = theme ? kebabToPascal(theme) : '';

    const favoriteClasses = classNames(styles['NavigationFavorite'], {
        [styles['NavigationFavorite--Filled']]: favoritesCount > 0,
        [styles['NavigationFavorite--Active']]: isActive,
        [styles[`NavigationFavorite--Theme${themeModifier}`]]: themeModifier,
        [styles['NavigationFavorite--ThemeDefault']]: !themeModifier,
        [styles['NavigationFavorite--Minimal']]: isMinimal,
    });

    return (
        <a className={favoriteClasses} href={favoritesPageUrl}>
            <span className={styles['NavigationFavorite__Text']}>{t('navigationFavorite.link')}</span>
            {favoritesCount > 0 && (
                <span className={styles['NavigationFavorite__NumberContainer']}>
                    <span className={styles['NavigationFavorite__Number']}>
                        {' '}
                        ({favoritesCount < 100 ? favoritesCount : '99+'})
                    </span>
                </span>
            )}
        </a>
    );
};

NavigationFavorite.propTypes = {
    favoritesPageUrl: PropTypes.string,
    theme: PropTypes.string,
    isMinimal: PropTypes.bool,
};

export default NavigationFavorite;
